import { Reveal, SectionHead } from "./Reveal";
import { Orbit } from "lucide-react";

const ABOUT_IMG =
    "https://images.unsplash.com/photo-1742844552699-2fb71ad66a72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200";

const STATS = [
    { value: "500+", label: "Spaces Captured" },
    { value: "9", label: "Industries Served" },
    { value: "24/7", label: "Always-Open Experiences" },
];

export default function About() {
    return (
        <section id="about" className="relative py-20 lg:py-32" data-testid="about-section">
            <div className="absolute -right-24 top-24 h-80 w-80 rounded-full bg-[#00C6FF]/8 blur-[130px]" />
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="grid items-center gap-14 lg:grid-cols-2">
                    <div>
                        <SectionHead
                            chapter="03"
                            eyebrow="About Us"
                            title="WE TURN SPACES INTO STORIES"
                        />
                        <Reveal delay={0.15}>
                            <p className="mt-6 text-base leading-relaxed text-slate-300 sm:text-lg">
                                Prime 360 View was born in Pune from a simple frustration —
                                beautiful businesses being judged by flat, forgettable
                                photos. We're a crew of capture specialists, 3D artists and
                                storytellers who believe your space should sell itself,
                                even at 2 AM.
                            </p>
                        </Reveal>
                        <Reveal delay={0.25}>
                            <p className="mt-5 text-base leading-relaxed text-slate-400">
                                From boutique cafés to sprawling factory floors, we've helped
                                hundreds of spaces welcome visitors long before they arrive.
                                Because when customers can explore freely, they don't just
                                book — they belong.
                            </p>
                        </Reveal>
                        <div className="mt-10 grid grid-cols-3 gap-4">
                            {STATS.map((s, i) => (
                                <Reveal key={s.label} delay={0.3 + i * 0.08}>
                                    <div
                                        className="glass-card rounded-2xl p-5 text-center"
                                        data-testid={`about-stat-${i}`}
                                    >
                                        <p className="text-2xl font-extrabold text-[#00C6FF] sm:text-3xl">
                                            {s.value}
                                        </p>
                                        <p className="mt-1.5 text-[10px] uppercase tracking-[0.2em] text-slate-400">
                                            {s.label}
                                        </p>
                                    </div>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                    <Reveal delay={0.2}>
                        <div className="relative">
                            <div className="overflow-hidden rounded-2xl border border-[#00C6FF]/25 shadow-[0_0_50px_rgba(0,198,255,0.12)]">
                                <img
                                    src={ABOUT_IMG}
                                    alt="Prime 360 View studio at work"
                                    loading="lazy"
                                    className="h-[440px] w-full object-cover"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-[#050B14]/85 via-transparent to-transparent" />
                                <div className="absolute bottom-6 left-6 right-6">
                                    <p className="font-mono-accent text-[10px] uppercase tracking-[0.3em] text-[#00C6FF]">
                                        Pune · Maharashtra
                                    </p>
                                    <p className="mt-1.5 text-lg font-semibold text-white">
                                        Explore · Experience · Grow
                                    </p>
                                </div>
                            </div>
                            <div className="absolute -right-5 -top-5 flex h-16 w-16 items-center justify-center rounded-full border border-[#00C6FF]/50 bg-[#050B14] shadow-[0_0_25px_rgba(0,198,255,0.35)]">
                                <Orbit size={26} className="orbit-ring text-[#00C6FF]" />
                            </div>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
